<template>
	<v-card class="create-card bg-secondary" width="800px" rounded="xl">
		<v-dialog class="loader" v-model="loader.showSubmittingLoader" persistent width="300px">
			<v-card>
				<v-card-title> Agent Details </v-card-title>
				<v-card-text style="display: grid; justify-content: center">
					<v-progress-circular indeterminate size="40"></v-progress-circular>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-card-title class="card__title__top">
			<strong>{{ $t('agent_information') }}</strong>
			<v-icon class="icon" @click="closeDialog">mdi-close</v-icon>

		</v-card-title>
		<v-header>
			<div style="height: 7rem; background-color: #ffc2c6"></div>
		</v-header>
		<v-card-text class="bg-white">
			<div>

				<v-avatar color="grey" size="150" class="ml-5" style=" position: relative;margin-top: -6rem;"
					:image="agent?.pictureUrl">
				</v-avatar>
				<v-btn size="45" icon="" style="
							position: absolute;
							left: 160px;
							z-index: 999;
							background-color: rgba(17, 17, 17, 0.7);
						" @click="pickFile">
					<v-icon size="24" class="text-white">
						mdi-image-edit
					</v-icon>
					<input ref="fileRef" class="d-none" type="file" @change="uploadImage($event)"></input>
				</v-btn>

				<div>
					<div class="mt-4">
						<label for="agentType" class="form-label">Types of Agent <span>*</span></label>
						<v-select class="rounded-xl" density="compact" variant="outlined"
							:model-value="getMappedAgentType()" @update:model-value="setMappedAgentType"
							:items="['IT Service', 'ESG']" placeholder="Select Type of Agent">
						</v-select>
					</div>

					<v-row>
						<v-col cols="6">

							<div class="mb-2">
								<label for="title" style="font-weight: 600">{{ $t('first_name') }}<span>*</span></label>
								<v-text-field variant="outlined" v-model="agent.firstName" density="compact"
									size="50"></v-text-field>

								<label for="title" style="font-weight: 600">{{ $t('email') }} <span>*</span></label>
								<v-text-field variant="outlined" v-model="agent.email" density="compact"
									size="50"></v-text-field>
							</div>


						</v-col>

						<v-col cols="6">
							<div class="my-2">
								<div>
									<label for="title" style="font-weight: 600">{{ $t('last_name')
									}}<span>*</span></label>
									<v-text-field variant="outlined" v-model="agent.lastName" density="compact"
										size="50" />
								</div>

								<div>
									<label for="title" style="font-weight: 600">{{ $t('contact_number')
									}}<span>*</span></label>

									<vue-tel-input :enabledCountryCode="true" mode="international" v-model="agent.phone"
										style="
											padding: 0.3rem;
											
										"></vue-tel-input>
								</div>
							</div>
						</v-col>
					</v-row>
				</div>
				<div>
					<label for="title" style="font-weight: 600">{{ $t('base_location') }}<span>*</span></label>
					<v-menu v-model="menuOpen" offset-y>
						<template v-slot:activator="{ props }">
							<v-text-field v-model="agent.address" placeholder="Select or type your location"
								variant="outlined" clearable dense v-bind="props" @input="handleInput"></v-text-field>
						</template>

						<v-list v-if="filteredSuggestions && filteredSuggestions.length > 0">
							<v-list-item v-for="(suggestion, index) in filteredSuggestions" :key="index"
								@click="selectSuggestion(suggestion)">
								<v-list-item-title v-html="highlightMatch(suggestion)"></v-list-item-title>
							</v-list-item>
						</v-list>

						<v-list v-else-if="agent.address?.length > 0">
							<v-list-item>
								<v-list-item-title>No results found</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
				<div>

					<label for="title" style="font-weight: 600">{{ $t('skill_required') }}<span>*</span></label>

					<vue3-tags-input style="padding: 0.3rem; text-transform: capitalize; margin-bottom: 14px;"
						:tags="tags" :placeholder="$t('enter_skills')"
						@on-tags-changed="handleChangeTag"></vue3-tags-input>
				</div>

				<div>
					<label for="title" style="font-weight: 600">{{ $t('certificate') }}
					</label>
					<v-menu v-model="isCreateCertificatesOpen" location="top" :close-on-content-click="false">
						<template #activator="{ props: menuProps }">
							<div v-bind="menuProps"
								class=" v-text-field-height border rounded-lg d-flex align-center justify-space-between">
								<div style="display: flex; flex-wrap: wrap; gap: 4px;">
									<span v-if="selectedCertificates.length === 0" class="placeholder-text"
										style="color: rgba(153, 153, 153, 1)">
										{{ $t('select-certificate') }}
									</span>
									<v-chip v-for="item in selectedCertificates" :key="item" class="mr-1" :style="{
										'background-color': colorGenerator(item),
										'color': 'white',
									}">
										{{ item }}
									</v-chip>
								</div>
								<v-icon @click.stop="this.isCreateCertificatesOpen = true">
									{{
										this.isCreateCertificatesOpen ? "mdi-chevron-up" : "mdi-chevron-down"
									}}
								</v-icon>
							</div>
						</template>
						<v-list width="750px" class=' mb-2' style="max-height: 300px;">
							<v-btn class="text-none pa-5 d-flex ml-10 justify-center align-center"
								style="border: 1px solid rgba(153, 153, 153, 1); width: 90%;" variant="outlined"
								@click="handleAddItemsDialogOpen">
								<div class="d-flex align-center">+ {{ $t('create_certificate') }}</div>
							</v-btn>

							<v-divider class="ma-1 my-2" />

							<v-list-item v-for="item in certificates" :key="item">
								<div class="d-flex justify-space-between align-center" style="width: 100%; ">
									<div>{{ item.name }}</div>
									<v-radio :value="item.name" v-model="selectedCertificates"
										@click.stop="toggleCertificateSelection(item.name)"
										style="display: flex;justify-content: end; color: rgba(46, 204, 113, 1);"></v-radio>
									<v-icon color="red" class="mr-3"
										@click.stop="deleteCertificatePopup(item.id, item.name)"
										style="cursor: pointer;">
										mdi-trash-can-outline
									</v-icon>
								</div>
							</v-list-item>
						</v-list>
					</v-menu>
				</div>
				<div>
					<div class="d-flex justify-space-between mt-4">
						<div>
							<label for="title" style="font-weight: 600">{{ $t('certificate_file') }}</label>
						</div>
						<div style="color: rgba(255, 126, 135, 1);text-decoration: underline;cursor: pointer;"
							@click="downloadAllFiles">{{ $t('download_all_files') }}</div>
					</div>
					<div class="d-flex flex-wrap">
						<div v-for="(document, index) in agent.agentDocument" :key="index" class="document-item">
							<div class="d-flex justify-space-between">
								<div class="d-flex">
									<div><v-icon>mdi-file-outline</v-icon> </div>
									<div>{{ truncateFileName(document.fileName) }}</div>
								</div>
								<div style="cursor: pointer;" @click="downloadSingleFile(document)">
									<v-icon>mdi-download</v-icon>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>


		</v-card-text>

		<v-card-actions class="card__footer">
			<v-card-title class="card__title__bottom" style="display: flex; justify-content: space-between">
				<div style="display: flex">
					<div>
						<button class="create-button" @click="updateAgentProfile">
							{{ $t('save_change') }}
						</button>
					</div>
				</div>

				<div v-if="!agent.pendingApproval && !agent.approved">
					<v-btn class="px-5 ml-10 rounded-xl bg-yellow-darken-3" size="small" elevation="0"
						@click="reapproveAgent(agent.id)">
						{{ $t('reapprove') }}
					</v-btn>
				</div>
				<div v-else>
					<v-btn class="px-5 ml-2 rounded-xl" style="background-color: rgba(255, 126, 135, 1)"
						@click="rejectAgent(agent.id)" size="small" elevation="0">
						{{ $t('decline') }}
					</v-btn>
					<v-btn class="px-5 rounded-xl" style="background-color: rgba(46, 204, 113, 1)"
						@click="approveAgent(agent.id)" size="small" elevation="0">
						{{ $t('approve') }}
					</v-btn>
				</div>


			</v-card-title>
		</v-card-actions>
		<v-dialog v-model="isAddItemsDialogOpen" width="500px">
			<v-card rounded='xl'>
				<v-card-header style="background-color: rgba(37, 37, 37, 1)">
					<div class="d-flex justify-space-between my-5 mx-4 text-white">
						<div>{{ $t('create_certificate') }}</div>
						<div @click="isAddItemsDialogOpen = false"><v-icon>mdi-close</v-icon></div>
					</div>
				</v-card-header>
				<v-card-text>
					<div>
						<div>{{ $t('certificate_name') }}</div>
						<div class='mt-3'><v-text-field :placeholder="$t('name')" variant="outlined"
								v-model="name"></v-text-field>
						</div>
						<div class="d-flex flex-row-reverse">
							<v-btn :disabled="!name" rounded="xl" color="rgba(46, 204, 113, 1)"
								class="text-none text-white px-5" @click="addCertificate">{{ $t('confirm') }}</v-btn>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialog" max-width="500" persistent>
			<v-card rounded=xl>

				<v-card-text class="mx-2 my-4">
					{{ $t('sure_delete_cerificate') }} <strong style="color:rgba(255, 126, 135, 1)">"{{
						certificateToDelete }}"</strong>?
				</v-card-text>
				<v-card-footer style="background-color: black;color: white;">
					<div class="d-flex justify-space-between ma-2">
						<v-btn variant="text" text @click="cancelDelete()" class='text-none'>{{ $t('cancel') }}</v-btn>
						<v-btn variant=text text @click="confirmDelete(this.certificateToDeleteId)">
							<div class="d-flex align-center text-none">
								<div class="mr-2">{{ $t('confirm') }} </div>
								<div><v-icon size="x-large">mdi-arrow-right-thin-circle-outline</v-icon></div>
							</div>
						</v-btn>

					</div>

				</v-card-footer>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import Vue3TagsInput from 'vue3-tags-input'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import AgentCertificate from '@/services/API/AgentCertificate';
export default {
	emits: ['emitUpdateAgentProfile', 'closeDialog', 'approveAgent',
		'rejectAgent',
		'reapproveAgent'],
	data: () => ({
		dialog: false, // To control the dialog visibility
		certificateToDelete: null, // The certificate to delete
		certificateToDeleteId: null,
		agent: {},
		isCreateNewProjectDialogOpen: false,
		certificates: [],
		selectedCertificates: [],
		isAddItemsDialogOpen: false,
		isCreateCertificatesOpen: false,
		name: "",
		file: null,
		tags: [],
		skills: [],
		skillset: [],
		timeRange: [
			'24 hours',
			'Morning',
			'Afternoon',
			'After 6:00 PM',
			'After 10:00 PM',
		],
		loader: {
			showSubmittingLoader: false,
		},
		formObj: {
			id: null,
			firstName: "",
			lastName: "",
			email: "",
			phone: "",
			address: "",
			certificateNames: [],
			skills: [],
			pictureUrl: "",
			type: '',

		},
		provinceList: [
			"Bangkok", "Amnat Charoen", "Ang Thong", "Bueng Kan", "Buriram",
			"Chachoengsao", "Chai Nat", "Chaiyaphum", "Chanthaburi", "Chiang Mai",
			"Chiang Rai", "Chonburi", "Chumphon", "Kalasin", "Kamphaeng Phet",
			"Kanchanaburi", "Khon Kaen", "Krabi", "Lampang", "Lamphun", "Loei",
			"Lopburi", "Mae Hong Son", "Maha Sarakham", "Mukdahan", "Nakhon Nayok",
			"Nakhon Pathom", "Nakhon Phanom", "Nakhon Ratchasima", "Nakhon Sawan",
			"Nakhon Si Thammarat", "Nan", "Narathiwat", "Nong Bua Lamphu",
			"Nong Khai", "Nonthaburi", "Pathum Thani", "Pattani", "Phang Nga",
			"Phatthalung", "Phayao", "Phetchabun", "Phetchaburi", "Phichit",
			"Phitsanulok", "Phra Nakhon Si Ayutthaya", "Phrae", "Phuket",
			"Prachinburi", "Prachuap Khiri Khan", "Ranong", "Ratchaburi", "Rayong",
			"Roi Et", "Sa Kaeo", "Sakon Nakhon", "Samut Prakan", "Samut Sakhon",
			"Samut Songkhram", "Saraburi", "Satun", "Sing Buri", "Sisaket",
			"Songkhla", "Sukhothai", "Suphan Buri", "Surat Thani", "Surin", "Tak",
			"Trang", "Trat", "Ubon Ratchathani", "Udon Thani", "Uthai Thani",
			"Uttaradit", "Yala", "Yasothon",
		],
		menuOpen: false,

	}),
	created() {

		this.fetchCertificates()
		this.agent = this.agentDetails;
		this.tags = this.agent.skills ? this.agent.skills.map((skill) => skill.name) : []

		if (!this.agent.roles || this.agent.roles.length === 0) {
			this.agent.roles = [{ type: '' }];
		}

		this.agent.agentCertificate.forEach((item) => {
			this.selectedCertificates.push(item.certificateName)
		})
	},
	components: {
		VueDatePicker,
		Vue3TagsInput,
	},
	props: {
		agentDetails: {
			type: Object,
			required: false,
		},
	},
	methods: {
		getMappedAgentType() {
			if (this.agent.roles[0]?.type === 'general') return 'IT Service';
			if (this.agent.roles[0]?.type === 'esg') return 'ESG';
			return null;
		},
		setMappedAgentType(value) {
			// Ensure agent.roles is initialized
			if (!this.agent.roles || this.agent.roles.length === 0) {
				this.agent.roles = [{ type: '' }];
			}
			// Update the type based on the selected value
			this.agent.roles[0].type = value === 'IT Service' ? 'general' : 'esg';
		},
		handleInput() {
			if (!this.agent.address || this.agent.address.length < 3) {
				this.filteredSuggestions = [];
				this.menuOpen = false;
				return;
			}

			// Filter suggestions based on the start of the text
			this.filteredSuggestions = this.provinceList.filter(province =>
				province.toLowerCase().startsWith(this.agent.address.toLowerCase())
			);

			// Open menu if results exist
			this.menuOpen = this.filteredSuggestions.length > 0;
		},

		selectSuggestion(province) {
			this.agent.address = province;
			this.menuOpen = false;
		},

		highlightMatch(suggestion) {
			if (!this.agent.address) return suggestion;

			const regex = new RegExp(`^(${this.agent.address})`, "gi");
			return suggestion.replace(regex, `<span class="highlight">$1</span>`);
		},
		deleteCertificatePopup(id, name) {
			if (this.selectedCertificates.includes(name)) {
				this.toggleCertificateSelection(name)
			}

			this.certificateToDelete = name;
			this.certificateToDeleteId = id;
			this.dialog = true; // Open the dialog

		},
		async confirmDelete(id) {
			await AgentCertificate.deleteCertificate(id).then(() => {
				this.dialog = false;
				this.fetchCertificates();
			})
		},
		cancelDelete() {
			this.agent.agentCertificate.forEach((item) => {
				if (this.selectedCertificates.includes(item.certificateName)) {
					this.dialog = false
				} else {
					this.toggleCertificateSelection(this.certificateToDelete)
				}
			})
			this.dialog = false;

		},

		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)

			return `#${hex}`
		},
		async fetchCertificates() {
			try {
				const response = await AgentCertificate.getAllCertificateName();
				if (response.status === 200) {
					this.certificates = response.data.map(cert => ({ id: cert.id, name: cert.certificateName }));
				} else {
					console.error('Failed to fetch certificates');
				}
			} catch (error) {
				console.error('An error occurred while fetching certificates:', error);
			}
		},
		reapproveAgent(id) {
			this.updateAgentProfile();
			this.$emit('reapproveAgent', id)
		},
		approveAgent(id) {
			this.updateAgentProfile();
			this.$emit('approveAgent', id)

		},
		rejectAgent(id) {
			this.$emit('rejectAgent', id)

		},
		closeDialog() {
			this.$emit('closeDialog')
		},
		pickFile() {
			this.$refs.fileRef.click()
		},
		uploadImage(event) {
			const file = event.target.files[0];

			if (file) {
				if (this.agent.pictureUrl) {
					URL.revokeObjectURL(this.agent.pictureUrl);
				}
				this.file = file
				this.agent.pictureUrl = URL.createObjectURL(file);
			}
		},
		handleChangeTag(tags) {
			this.tags = tags
		},
		truncateFileName(fileName) {
			// If the file name is longer than 15 characters, truncate and add ellipsis
			return fileName.length > 15 ? fileName.slice(0, 15) + '...' : fileName;
		},
		downloadAllFiles() {
			if (this.agent.agentDocument && this.agent.agentDocument.length > 0) {
				this.agent.agentDocument.forEach((url, index) => {
					setTimeout(() => {
						const link = document.createElement("a");
						link.href = url.documentUrl;
						link.download = url.fileName || `file-${index + 1}`; // Use filename or a fallback
						link.target = "_blank";

						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}, index * 500); // 500ms delay between each download
				});
			}
		},
		downloadSingleFile(url) {

			const link = document.createElement("a");
			link.href = url.documentUrl;
			link.download = url.fileName // Use the filename provided by the server if available
			// Set target="_blank" to open the file in a new tab
			link.target = "_blank";

			// Append the anchor to the body
			document.body.appendChild(link);

			// Trigger the download
			link.click();

			// Remove the anchor from the document
			document.body.removeChild(link);
		},
		toggleCertificateSelection(item) {
			if (this.selectedCertificates.includes(item)) {
				this.selectedCertificates = this.selectedCertificates.filter(
					(selectedItem) => selectedItem !== item
				);
			} else {
				this.selectedCertificates.push(item);
			}
		},
		handleAddItemsDialogOpen() {
			this.name = '';
			this.isAddItemsDialogOpen = true;
			this.isCreateCertificatesOpen = false;
			this.isCreateNewProjectDialogOpen = false;
		},
		async addCertificate() {
			if (this.name) {
				const resp = await AgentCertificate.postNewCertificateName({ certificateName: this.name })
				if (await resp.status === 200) {
					this.certificates.push(this.name); // Add the new certificate
					//  this.name = ''; // Reset the input field
					this.fetchCertificates()
					this.isAddItemsDialogOpen = false; // Close the dialog
				}

			}
		},


		updateAgentProfile() {
			this.formObj.id = this.agent.id;
			this.formObj.firstName = this.agent.firstName;
			this.formObj.lastName = this.agent.lastName;
			this.formObj.email = this.agent.email;
			this.formObj.phone = this.agent.phone;
			this.formObj.address = this.agent.address;
			this.formObj.certificateNames = this.selectedCertificates;
			this.formObj.skills = this.tags;
			this.formObj.pictureUrl = this.file;
			this.formObj.type = this.agent.roles[0]?.type || '';
			this.$emit('emitUpdateAgentProfile', this.formObj);
			this.closeDialog();

		},
	},

}
</script>

<style scoped>
.v-text-field fieldset {
	color: red !important;
	background-color: green !important;
	border-radius: 4px !important;
	border: #3dc4fa !important;
}

.create-card {
	width: 75vw;
	font-family: Roboto;
	font-weight: 600;
}

.second-col {
	scrollbar-width: none;
	-ms-overflow-style: none;
	/* For Internet Explorer and Edge */
}

.second-col::-webkit-scrollbar {
	display: none;
}

.card__title__top,
.card__title__bottom {
	color: white;
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
}

.icon {
	justify-self: right;
}

.new-detail {
	color: #a3a3a3;
	text-decoration: none;
}

.reset-button {
	justify-self: self-start;
	font-size: 1.3rem;
	margin-left: 1rem;
}

.create-button {
	justify-self: end;
	font-size: 1.3rem;
	margin-right: 1rem;
}

.card__footer {
	color: white;
}

.new-job-detail-form,
.job-detail-form {
	margin-top: 1rem;
}

.loader {
	width: 70%;
}

.max-height {
	max-height: 576px;
}

.v-list-item--active {
	background-color: #3273f6 !important;
	color: white !important;
	border-radius: 10px;
}

.responsive-phone-field {
	padding: 0.3rem;
	width: 100%;
	/* Set initial width to 100% */
}

.document-item {
	width: 45%;
	/* Adjusts width to accommodate 2 items per row with some spacing */
	border: 1px solid rgba(153, 153, 153, 1);
	border-radius: 20px;
	padding: 10px;
	margin: 5px;
}


/* Remove the border from each list item */
.v-list-item {
	border: none !important;
	/* Remove any border from the v-list-item */
	box-shadow: none !important;
	/* Remove any shadow around the list item */
}

/* Optional: Add a custom border style to each list item */
.v-text-field-height {
	min-height: 47px;
	/* Adjust this height to match your v-text-field */
	padding: 0 12px;
	/* Adjust padding to align content vertically */
	display: flex;
	align-items: center;
	/* Align items vertically within the div */
	box-sizing: border-box;
	/* Include padding and border in height calculation */
}
</style>
